
/**
 * Formata um número para o formato brasileiro (1.234,56)
 */
export const formatBrazilianNumber = (value: number | string): string => {
  if (value === '' || value === undefined || value === null) return '';
  const num = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;
  if (isNaN(num)) return '';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 10,
  }).format(num);
};

/**
 * Remove a formatação brasileira e retorna um número puro (string para input)
 */
export const parseBrazilianNumber = (value: string): string => {
  // Remove pontos (milhar) e troca vírgula por ponto (decimal)
  return value.replace(/\./g, '').replace(',', '.');
};

/**
 * Máscara para inputs de dinheiro/número enquanto o usuário digita
 */
export const maskCurrency = (value: string): string => {
  // Remove tudo que não é dígito
  let cleanValue = value.replace(/\D/g, '');

  // Se estiver vazio, retorna vazio
  if (!cleanValue) return '';

  // Converte para número e formata com centavos
  const amount = (parseInt(cleanValue) / 100).toFixed(2);
  const [inteiros, centavos] = amount.split('.');

  const formattedInteiros = inteiros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedInteiros},${centavos}`;
};

/**
 * Máscara para inputs numéricos com 2 casas decimais automáticas (estilo brasileiro)
 * Ex: Digitar "1" resulta em "0,01". Digitar "123" resulta em "1,23".
 */
/**
 * Máscara para inputs numéricos decimais flexíveis
 * Permite digitar números livremente e formata conforme necessário.
 * Não divide por 100 automaticamente.
 */
export const maskNumber = (value: string): string => {
  // Remove tudo que não é dígito ou vírgula
  let cleanValue = value.replace(/[^\d,]/g, '');

  // Garante apenas uma vírgula
  const parts = cleanValue.split(',');
  if (parts.length > 2) {
    cleanValue = parts[0] + ',' + parts.slice(1).join('');
  }

  // Formata a parte inteira com pontos de milhar
  const integerPart = parts[0].replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1] !== undefined ? ',' + parts[1].slice(0, 2) : '';

  return integerPart + decimalPart;
};

/**
 * Máscara para números inteiros (sem decimais)
 */
export const maskInteger = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '');
  if (!cleanValue) return '';
  return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
